import React, { useEffect, useState } from 'react';
import { Plus, X, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { formatDate } from '../lib/format';

const FORMATS = ['reel','carousel','story','static'];
const STATUSES = ['idea','drafted','scheduled','posted'];

export default function ContentCalendar() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get('/content-posts').then(r => setItems(r.data.filter(x => !x.deleted_at)));
  useEffect(() => { load(); }, []);
  const save = async (p) => { if (p.id) await api.put(`/content-posts/${p.id}`, p); else await api.post('/content-posts', p); toast.success('Saved'); setEdit(null); load(); };
  const rm = async (id) => { await api.delete(`/content-posts/${id}`); load(); };
  // Group by upcoming 30 days
  const today = new Date().toISOString().slice(0,10);
  const in30 = new Date(Date.now() + 30*86400000).toISOString().slice(0,10);
  const upcoming = items.filter(x => x.post_date && x.post_date >= today && x.post_date <= in30).sort((a,b) => a.post_date.localeCompare(b.post_date));
  const backlog = items.filter(x => !x.post_date || x.post_date < today || x.post_date > in30);
  return (
    <div className="px-5 py-5 lg:px-10 lg:py-8 max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-5">
        <div><div className="eyebrow">Content</div><h1 className="serif text-[28px]">Content Calendar</h1></div>
        <button className="btn-gold" onClick={() => setEdit({ post_date: today, format: 'reel', status: 'idea' })} data-testid="content-add"><Plus size={14}/> Add Post</button>
      </div>
      <div className="mb-5">
        <div className="eyebrow mb-2">Next 30 Days</div>
        <div className="space-y-2">
          {upcoming.length === 0 && <div className="text-sm text-[var(--muted)] italic">Nothing scheduled.</div>}
          {upcoming.map(p => (
            <div key={p.id} className="card-cream p-3 cursor-pointer hover:bg-[var(--cream-alt)]" onClick={() => setEdit(p)}>
              <div className="flex justify-between gap-3">
                <div><div className="text-xs text-[var(--muted)] tracking-[0.14em] uppercase">{formatDate(p.post_date)} · {p.format}</div><div className="serif text-[17px]">{p.topic || '(untitled)'}</div></div>
                <span className={`status-pill status-${p.status==='posted'?'ok':p.status==='scheduled'?'pending':'draft'}`}>{p.status}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {backlog.length > 0 && (
        <div>
          <div className="eyebrow mb-2">Backlog / Past</div>
          <div className="space-y-2">
            {backlog.map(p => (
              <div key={p.id} className="card-cream p-3 cursor-pointer hover:bg-[var(--cream-alt)]" onClick={() => setEdit(p)}>
                <div className="flex justify-between"><div><div className="text-xs text-[var(--muted)]">{p.post_date?formatDate(p.post_date):'no date'} · {p.format}</div><div className="serif text-[16px]">{p.topic}</div></div><span className={`status-pill status-${p.status==='posted'?'ok':'draft'}`}>{p.status}</span></div>
              </div>
            ))}
          </div>
        </div>
      )}
      {edit && (
        <div className="fixed inset-0 z-50 flex items-end lg:items-center justify-center bg-black/40 p-0 lg:p-6">
          <div className="w-full max-w-md card-cream p-6 space-y-3 overflow-y-auto max-h-[92vh]">
            <div className="flex items-center justify-between"><h2 className="serif text-[22px]">Post</h2><button onClick={() => setEdit(null)}><X size={18}/></button></div>
            <div className="grid grid-cols-2 gap-3">
              <div><label className="eyebrow">Date</label><input type="date" value={edit.post_date||''} onChange={e => setEdit({...edit, post_date: e.target.value})}/></div>
              <div><label className="eyebrow">Format</label><select value={edit.format} onChange={e => setEdit({...edit, format: e.target.value})}>{FORMATS.map(f => <option key={f}>{f}</option>)}</select></div>
              <div><label className="eyebrow">Status</label><select value={edit.status} onChange={e => setEdit({...edit, status: e.target.value})}>{STATUSES.map(s => <option key={s}>{s}</option>)}</select></div>
            </div>
            <div><label className="eyebrow">Topic</label><input value={edit.topic||''} onChange={e => setEdit({...edit, topic: e.target.value})}/></div>
            <div><label className="eyebrow">Caption draft</label><textarea rows={4} value={edit.caption||''} onChange={e => setEdit({...edit, caption: e.target.value})}/></div>
            <div><label className="eyebrow">Hashtags</label><textarea rows={2} value={edit.hashtags||''} onChange={e => setEdit({...edit, hashtags: e.target.value})}/></div>
            <div className="flex gap-2">
              {edit.id && <button className="btn-ghost text-xs flex-1" onClick={() => { rm(edit.id); setEdit(null); }} style={{color:'var(--overdue)'}}><Trash2 size={12}/> Delete</button>}
              <button className="btn-gold flex-1" onClick={() => save(edit)} data-testid="content-save">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
